import { Box } from "@mui/material";
import { IoMdClose } from "react-icons/io";

export default function PrivacyAndPolicy({ close }) {
  return (
    <Box
      style={{
        height: "100svh",
        width: "100svw",
        position: "fixed",
        backgroundColor: "white",
        display: "grid",
        gridTemplateRows: "auto auto",
      }}
    >
      {/* header */}
      <Box
        style={{
          backgroundColor: "#F07821",
          height: "3rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0rem 1rem",
        }}
      >
        <h4
          style={{
            fontSize: "1.0625rem",
            color: "white",
            fontWeight: "600",
          }}
        >
          Privacy and policy
        </h4>
        <IoMdClose
          style={{
            // fontWeight: "400",
            color: "white",
            // padding: "1px",
          }}
          onClick={() => close(false)}
        />
      </Box>

      {/* other modals */}

      <Box
        style={{
          padding: "1.5rem",
          overflowY: "auto",
        }}
      >
        <div>
          <h1>PRIVACY POLICY</h1>

          <p>
            <strong>Effective Date:</strong> 04 September 2025
          </p>
          <p>
            <strong>Last Updated:</strong> 04 September 2025
          </p>

          <p>
            At Visaero (Visaero Travel and Tourism LLC / M/s Visaero Pte Ltd /
            Visaero India Pvt. Ltd) (collectively, “Visaero”, “we”, “our”, or
            “us”), your privacy is of utmost importance to us. We are committed
            to protecting your personal data and ensuring that it is collected,
            processed, stored, transferred, and disclosed in a fair,
            transparent, and secured manner, and always in accordance with
            applicable legal, regulatory, and contractual requirements.
          </p>

          <p>
            This Privacy Policy explains in detail how Visaero handles personal
            information in connection with your use of our platform VisaLancer
            (the “Platform”). It describes the categories of information we may
            collect, the purpose for which such information may be used, the
            circumstances under which it may be shared, and the measures we
            adopt to protect it.
          </p>

          <p>
            By registering as a VisaLancer, sharing or using referral links, or
            otherwise accessing or using our services, you acknowledge that you
            have read, understood, and agreed to this Privacy Policy. You
            further consent to Visaero’s collection, use, and processing of your
            personal information in accordance with this Privacy Policy, subject
            to the rights available to you under applicable laws.
          </p>

          <h2>1. Definitions</h2>
          <p>
            For the purposes of this Privacy Policy, unless the context
            otherwise requires, the following terms shall have the meanings
            assigned below:
          </p>
          <p>
            <b>“Company” / “we” / “our” / “us”:</b> refers to the entity that
            operates the Platform and provides services to VisaLancers,
            including any affiliates, subsidiaries, or authorized partners.
          </p>
          <p>
            <b>“VisaLancer”:</b> refers any individual or entity that registers
            on the Platform for the purpose of sharing referral links, promoting
            Visaero’s services, and earning commission in accordance with the
            Platform’s terms.
          </p>
          <p>
            <b>“Platform”:</b> refers to the online platform, applications,
            websites, systems, and related services through which VisaLancers
            may register, generate and share referral links, track referrals,
            and receive commission.
          </p>
          <p>
            <b>“Personal Information” / “Personal Data”:</b> refers to any
            information, whether alone or in combination with other data, that
            can directly or indirectly identify an individual as a VisaLancer,
            including but not limited to name, email address, phone number,
            government-issued identification, financial details, device
            information, location data, or transaction-related information.
          </p>
          <p>
            <b>“Sensitive Personal Information”:</b> refers to such categories
            of information that, by their nature, require a higher degree of
            protection, including but not limited to financial account details,
            authentication credentials, or any information designated as
            sensitive under applicable regulations.
          </p>
          <p>
            <b>“Services”:</b> refers to all features, functionalities, content,
            and offerings made available by Visaero through the Platform,
            referral tracking, commission management, payout processing, and
            customer engagement services.
          </p>
          <p>
            <b>“Processing”:</b> refers to any operation or set of operations
            performed on Personal Information, whether automated or manual,
            including but not limited to collection, recording, organization,
            storage, adaptation, alteration, retrieval, use, disclosure,
            transmission, dissemination, erasure, or destruction.
          </p>
          <p>
            <b>“Third Party”:</b> refers to an entity engaged by Visaero to
            provide services on its behalf (e.g., payment processors, IT
            vendors, analytics providers).
          </p>

          <h3>Interpretation & Applicability</h3>
          <p>
            The definitions set out in Section 1 (Definitions) shall apply
            throughout this Privacy Policy and shall have the same meaning
            whether used in singular or plural form, in capitalized or
            non-capitalized form, unless the context otherwise requires.
          </p>
          <p>
            Headings, titles, and section numbers are provided for convenience
            only and shall not affect the interpretation of this Privacy Policy.
          </p>
          <p>
            References to “including,” “such as,” or similar terms shall be
            deemed to be followed by the words “without limitation.”
          </p>
          <p>
            In the event of any inconsistency or conflict between the provisions
            of this Privacy Policy and the Terms of Use or any other agreement
            entered into with Visaero, the interpretation of Visaero shall
            prevail to the extent permitted under applicable law, provided that
            nothing in this clause shall limit or prejudice the rights of
            Visalancer under applicable Data Protection requirements.
          </p>

          <h3>Scope of Consent</h3>
          <p>
            By registering on the Platform, as a Visalancer, thereafter creating
            a VisaLancer account, generating or sharing referral links,
            completing transactions, or otherwise accessing or using the
            Services, you expressly acknowledge and consent to the collection,
            use, storage, processing, transfer, and disclosure of your Personal
            Information by Visaero in accordance with the terms of this Privacy
            Policy.
          </p>
          <p>Such consent shall extend to:</p>
          <p>
            The processing of your Personal Information for the purposes
            described in this Privacy Policy;
          </p>
          <p>
            The disclosure of your Personal Information to Visaero’s service
            providers, and third parties as outlined herein;
          </p>
          <p>
            The transfer of your Personal Information across jurisdictions where
            Visaero or its service providers operate, subject to applicable
            safeguards; and
          </p>
          <p>
            The retention of your Personal Information for as long as necessary
            to fulfill the purpose set out in this Privacy Policy or as required
            under applicable laws.
          </p>
          <p>
            Your consent is informed, freely given, and specific to the purpose
            described herein, and that you have the right to withdraw such
            consent at any time by contacting Visaero at the details provided in
            this Privacy Policy. However, such withdrawal may limit or restrict
            your ability to access or use certain features of the Services.
          </p>
          <p>
            Notwithstanding withdrawal of consent, Visaero may retain such
            Personal Information as is necessary for legitimate business
            purposes, including verification of past referrals, calculation of
            commission, fraud prevention, and compliance with tax or accounting
            obligations.
          </p>

          <h2>2. Personal Information We Collect</h2>
          <p>
            Visaero collects information that identifies, relates to, describes,
            or is reasonably capable of being associated, directly or
            indirectly, with a Visalancer, Referred Customer, or other data
            subject (“Personal Information”). Except as expressly stated herein,
            Personal Information may be stored on Visaero’s servers or on your
            device as necessary for the provision of Services. By registering on
            the Platform, creating a VisaLancer account or otherwise accessing
            you consent to the collection, use, storage, processing, transfer,
            and disclosure of your Personal Information in accordance with this
            Privacy Policy.
          </p>
          <p>
            Personal Information is collected only when it is provided
            voluntarily by a Visalancer required for the performance of
            Services, or necessary to comply with legal, regulatory, or
            contractual obligations.
          </p>
          <p>
            The types of Personal / Sensitive Information Visaero may collect,
            directly or indirectly, include, but are not limited to, the
            following categories.
          </p>
          <p>
            <b>Contact and identification information,</b> such as name, email
            address, phone number, government-issued identification, and other
            details enabling accurate identification of a Visalancer.
          </p>
          <p>
            <b>Business and professional information,</b> including employer
            name and address, business email and telephone number, employment
            status, and related professional details.
          </p>
          <p>
            <b>Payment and financial information,</b> such as billing address,
            bank account and routing information, payment card details, and
            other information required to process commissions, payouts, or
            transactions.
          </p>
          <p>
            <b>Usage and preference information,</b> including referral
            activity, transactions, settings, preferences, and unique
            identifiers assigned to each Visalancer.
          </p>
          <p>
            <b>Device and technical information,</b> including device
            identifiers, hardware model, operating system and version, browser
            information, IP address, software or file information, preferred
            language, advertising identifiers, serial number, device motion
            information, mobile network information, and information stored on
            your device necessary to provide Services, such as contact lists,
            installed applications, and call logs.
          </p>
          <p>
            <b>Location information,</b> including GPS data, cellular service
            provider location data, or other geolocation information provided by
            the Visalancer.
          </p>
          <p>
            <b>Sensitive Personal Information,</b> such as health records or
            other sensitive categories where necessary for the provision of
            Services, which may be temporarily stored on Visaero servers for
            processing before secure deletion.
          </p>
          <p>
            <b>Non-Personal Information,</b> including aggregated, anonymized,
            or de-identified information collected automatically through the
            Platform, web analytics tools, or connected third-party
            applications.
          </p>
          <p>
            This list is illustrative and may vary depending on the Services
            provided, and Visaero reserves the right to collect additional
            information as necessary to provide or improve the Platform.
          </p>
          <p>
            Personal / Sensitive Information may be stored and processed in any
            jurisdiction in which Visaero or its service providers maintain
            facilities, including outside the VisaLancer’s country of residence.
            Visaero ensures that such transfers are conducted in accordance with
            applicable laws and implements appropriate safeguards, including
            contractual, technical, and organizational measures, to protect
            Personal / Sensitive Information. By using the Platform, you consent
            to such cross-border transfers. While the Company employs technical
            and organizational measures to safeguard Personal and Sensitive
            Information, absolute security cannot be guaranteed. Visalancer
            acknowledges and accepts the inherent risks of digital transmission
            and storage of information. Certain minimal categories of Personal /
            Sensitive Information may continue to be retained on servers for
            legitimate operational purposes, including maintaining Visalancer
            identifiers for accurate tracking of referrals and commission
            payments, even if the Visalancer discontinues use of the Platform.
          </p>
          <p>
            By providing Personal / Sensitive Information to Visaero, Visalancer
            represents and warrants that the information is accurate, complete,
            and, lawfully provided. Visalancer further acknowledges that failure
            to provide accurate information may restrict or impair access to
            specific Platform features, earn commissions, or access Services.
          </p>
          <p>
            Visaero may also collect information via third-party platforms or
            services that a Visalancer chooses to connect to the Platform,
            including social media accounts, email services, payment processors,
            and promotional partners (“Third-Party Services”). Depending on the
            VisaLancer’s consent, such information may include identifiers,
            contact information, connections, usage activity, and other data
            necessary to provide or enhance the Services, depending on the
            Visalancer’s settings and consents. By linking or integrating
            accounts with Third-Party Services, Visalancers expressly authorize
            Visaero to access, collect, and process such information in
            accordance with this Privacy Policy. Visalancer remain solely
            responsible for reviewing and complying with the privacy policies of
            such Third-Party Services.
          </p>
          <p>
            Information received from Third-Party Services may be used to
            facilitate the creation and management of VisaLancer accounts, track
            referral activity and calculate commissions or rewards, improve and
            personalize the Platform experience, conduct analytics, reporting,
            and operational optimizations, and comply with legal or regulatory
            obligations. Visaero may also collect non-personal or anonymized
            such usage trends, and engagement metrics, which will not personally
            identify Visalancer unless explicitly combined with Personal
            Information under this Privacy Policy.
          </p>
          <p>
            Except as expressly authorized by Visalancer or required for the
            provision of Services, Visaero does not allow third parties to
            access Personal Information collected through integrations and
            assumes no responsibility or liability for the practices of such
            third parties outside the Platform. Visalancer agree that Visaero is
            not responsible for any unauthorized access, disclosure, or misuse
            of information by Third-Party Services. Visaero disclaims any
            liability for data handling practices of Third-Party Services, and
            VisaLancers agree to review and comply with such third-party
            policies independently.
          </p>
          <p>
            Visaero may use cookies, web beacons, and similar tracking
            technologies to operate and improve the Platform, analyze usage
            patterns, and provide personalized experiences. Visalancer may
            manage preferences or opt out via account settings or browser
            controls.
          </p>
          <p>
            Visaero may monitor, track, and record activity on the Platform for
            fraud detection, compliance, and quality assurance purposes.
          </p>

          <h2>3. Sources of Personal / Sensitive Information</h2>
          <p>
            Visaero collects Personal / Sensitive Information from Visalancer
            primarily for the purpose of providing, maintaining, and improving
            the VisaLancer Platform and associated Services. All information is
            collected lawfully and in accordance with applicable Data protection
            requirements.
          </p>
          <p>
            Personal / Sensitive Information may be obtained directly from
            Visalancer when they register on the Platform or create a VisaLancer
            account, generate or share referral links, complete transactions, or
            otherwise engage with the Services. Visalancer may also provide such
            Information voluntarily through surveys, assessments, feedback
            forms, or other interactive features of the Platform.
          </p>

          <h2>4. Information We Share</h2>
          <p>
            Visaero does not sell or rent the Personal / Sensitive Information
            of Visalancer. Personal / Sensitive Information will not be shared
            with third parties for any marketing purposes, except as expressly
            described in this Privacy Policy or with the consent of the
            Visalancer.
          </p>
          <p>
            Visaero may share Personal / Sensitive Information under certain
            circumstances to support the operation, security, and legal
            compliance of the Platform and Services. Personal / Sensitive
            Information may be shared with Visaero for legitimate business,
            operational, and administrative purposes, including managing the
            Platform, and providing Services. Personal / Sensitive Information
            may be shared with third-party service providers retained to perform
            services on Visaero’s behalf, such as payment processors, cloud
            infrastructure providers, data analytics providers, and IT and
            security service providers. All service providers are contractually
            obligated to use Personal / Sensitive Information solely to perform
            services on Visaero’s behalf or comply with legal obligations, to
            maintain reasonable safeguards to protect the privacy and security
            of Personal / Sensitive Information, and not to sell, rent, or use
            Personal / Sensitive Information for their own marketing purposes.
          </p>
          <p>
            Visaero may also disclose Personal / Sensitive Information if
            required or permitted by law, including in response to subpoenas,
            court orders, or other legal processes; to comply with requests from
            governmental or regulatory authorities, including law enforcement,
            embassies, or consulates; to establish, exercise, or defend legal
            rights; to prevent potential physical, financial, or other harm; or
            in connection with investigations of suspected or actual illegal
            activity, fraud, security breaches, or technical issues.
          </p>
          <p>
            In the event Visaero sells, merges, or transfers all or a portion of
            its business or assets, Personal / Sensitive Information may be
            transferred as part of the transaction. Visaero will use
            commercially reasonable efforts to ensure that any transferee uses
            such Information in a manner consistent with this Privacy Policy.
          </p>

          <h2>5. Your Choices</h2>
          <p>
            Visaero respects Visalancer’ rights to manage their Personal
            Information. To the extent permitted by applicable law, Visalancer
            (the “Requestor”), may submit verifiable requests regarding the use,
            access, or sharing of Personal Information collected through the
            VisaLancer Platform. Requestor may submit verifiable requests
            regarding the use, access, or sharing of Personal Information
            collected through the Platform, Requestor may request to access
            Personal Information maintained by Visaero, correct or amend
            information that is inaccurate or incomplete, delete or erase
            Personal Information subject to legal, contractual, or operational
            retention requirements, restrict or object to the processing or
            sharing of Personal Information with third parties, or withdraw
            consent for specific uses of Personal Information where applicable.
          </p>
          <p>
            To protect privacy and ensure security, Visaero will take reasonable
            steps to verify the identity of the Requestor. Verification may
            require submission of documents or other information sufficient to
            confirm the Requestor’s identity and authority. Requests must be
            submitted through the contact channels provided in the “How to
            Contact Us” section of this Privacy Policy.
          </p>
          <p>
            Visaero may deny requests if compliance would conflict with
            applicable legal or regulatory obligations, interfere with
            contractual or operational requirements, or pose a risk to the
            security, integrity, or functioning of the Platform or Services. In
            such cases, Visaero will provide the Requestor with a written
            explanation of the reasons for denial. Visalancer retains control
            over the Personal Information they provide to Visaero, and choosing
            not to provide, or restricting the use of, certain Personal /
            Sensitive Information may limit or prevent access to some features
            or Services offered through the VisaLancer Platform. Requests for
            deletion of data will not affect Visaero’s right to retain
            transaction records necessary for payment reconciliation,
            accounting, taxation, or fraud prevention.
          </p>
          <p>
            By registering on the Platform, Visalancer consent to receive
            communications from Visaero regarding Services, promotions, or
            offers. Visalancer may opt out of marketing communications at any
            time through their account settings or by contacting Visaero as
            provided in Section (How to Contact Us).
          </p>

          <h2>6. How We Protect Personal / Sensitive Information</h2>
          <p>
            Visaero maintains reasonable administrative, technical and physical
            safeguards designed to protect personal information against
            accidental, unlawful or unauthorized loss, alteration, access,
            disclosure or use. We have designed our systems incorporating the
            concept of Privacy by design. Sensitive Biometric information is
            stored on your device only and is not transferred to the company
            servers. Sensitive health information where collected is encrypted,
            processed and securely deleted after the applicable retention
            period. Notwithstanding these measures, no electronic data
            transmission or storage of information can be guaranteed to be 100%
            secure. VisaLancer acknowledges that they provide information to
            Visaero at their own risk and Visaero cannot ensure or warrant the
            absolute security of any transmitted information.
          </p>
          <p>
            Visalancer is further responsible for maintaining the
            confidentiality of their account credentials, ensuring that their
            devices remain adequately secured, and promptly notifying Visaero of
            any suspected unauthorized access or use.
          </p>
          <p>
            Visaero makes no representations or warranties regarding the
            operation, availability, or functionality of the Platform, the
            Services, or any features thereof. Visalancer acknowledges that the
            Platform may experience outages, delays, errors, or other technical
            issues, and Visaero shall not be liable for any direct or indirect
            losses arising from such occurrences. Visalancer accesses and uses
            the Platform at their own risk.
          </p>

          <h2>7. Limitation of Liability / Indemnity</h2>
          <p>
            To the maximum extent permitted by applicable law, Visaero shall not
            be liable for any direct, indirect, incidental, consequential,
            punitive, or special damages, including loss of profits, arising
            from or in connection with the use, storage, or processing of
            Personal Information, including any unauthorized access, breach, or
            misuse beyond Visaero’s reasonable control. Visaero’s total
            cumulative liability under this Privacy Policy shall not exceed the
            total commission actually paid to the VisaLancer in the preceding
            six (6) months. Visalancer agrees to indemnify, defend, and hold
            Visaero harmless from any claims, damages, or losses arising from
            use, or processing of their Personal or Sensitive Information.
          </p>

          <h2>8. Updates to Our Privacy Policy</h2>
          <p>
            Visaero may update or revise this Privacy Policy from time to time
            to reflect changes in our Services, business practices, legal or
            regulatory requirements, or data privacy and security practices.
            Material changes will be communicated by posting a notice at the top
            of this Privacy Policy, and the “Last Updated” date will indicate
            when the Privacy Policy was most recently revised.
          </p>
          <p>
            Visalancers are encouraged to periodically review the Privacy Policy
            to stay informed of any updates. Continued use of the VisaLancer
            Platform following the posting of updates constitutes acceptance of
            the revised Privacy Policy.
          </p>
          <p>
            Visaero reserves the right, at its sole discretion, to modify,
            suspend, or discontinue any aspect of the Platform or Services,
            including referral programs, commission structures, or payout
            mechanisms, at any time, with or without notice. Visaero shall not
            be liable to Visalancer for any modification, suspension, or
            discontinuation of the Platform or Services.
          </p>

          <h2>9. No Waiver</h2>
          <p>
            The failure or delay by Visaero to exercise or enforce any right or
            provision under this Privacy Policy shall not constitute a waiver of
            such right or provision. Any waiver must be in writing and signed by
            an authorized representative of Visaero.
          </p>

          <h2>10. Force Majeure</h2>
          <p>
            Visaero shall not be liable for any failure or delay in the
            performance of its obligations under this Privacy Policy due to
            causes beyond its reasonable control, including, without limitation,
            acts of God, natural disasters, war, terrorism, government action,
            strikes, cyberattacks, or network failures.
          </p>

          <h2>11. Data Protection Officer / Compliance Contact</h2>
          <p>
            Visaero has designated a Chief Privacy Officer responsible for
            overseeing compliance with applicable data protection laws.
            Visalancer may contact the Chief Privacy Officer with questions,
            concerns, or to exercise their rights regarding Personal Information
            using the contact details provided in Section 15 (How to Contact
            Us).
          </p>

          <h2>12. Dispute Resolution / Governing Law</h2>
          <p>
            Any disputes arising from this Privacy Policy shall be governed by
            the laws and dispute resolution procedures set forth in the
            VisaLancer Terms of Use, to the extent permitted by applicable data
            protection laws.
          </p>

          <h2>13. How to Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests regarding this
            Privacy Policy, or wish to exercise your rights with respect to
            Personal Information (such as access, correction, deletion, or
            restriction of processing), you may contact Visaero through any of
            the following channels:
          </p>
          <p>
            <b>Email:</b> Send your inquiry to{" "}
            <a href="mailto:dpo@visaero.co">dpo@visaero.co</a> Please include
            sufficient details to enable us to identify your account or the
            relevant Personal Information.
          </p>
          <p>
            <b>Mail:</b> Write to us at:
            <br />
            Visaero
            <br />
            Attention: Data Protection Officer
          </p>
          <p>
            <b>Privacy Settings:</b> Access and manage your privacy preferences
            directly through your account on the VisaLancer Platform, where
            applicable.
          </p>
          <p>
            Visaero will take reasonable steps to verify the identity of the
            Requestor before fulfilling any requests concerning Personal /
            Sensitive Information. Note that we may require additional
            information to confirm your authority to act on behalf of another
            data subject. Responses will be provided in accordance with
            applicable law and Visaero’s operational practices.
          </p>

          <h2>14. Consent and Acknowledgment</h2>
          <p>By ticking the checkbox (where applicable), I confirm that:</p>
          <p>I have read and understood the Privacy Policy of Visaero.</p>
          <p>
            I consent to the collection, use, storage, and processing of my
            personal and Sensitive data in accordance with this Policy and
            applicable data protection laws.
          </p>
          <p>
            Where consent is required for specific purposes, I understand that I
            may withdraw my consent at any time by contacting{" "}
            <a href="mailto:dpo@visaero.co">dpo@visaero.co</a>.
          </p>
        </div>
      </Box>
    </Box>
  );
}
